import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/firestore';
import { AngularFireStorage, AngularFireStorageReference } from '@angular/fire/storage';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';
import { Onderneming } from '../models/Onderneming';
import { ToastComponent } from '../shared/toast/toast.component';
import { DataService } from './data.service';
import { VaaService } from './vaa.service';
import { HolidayValueService } from './Holiday-value.service';
import { AanwerfSimulatorService } from './aanwerf-simulator.service';
import { Cash4BikeService } from './cash4-bike.service';
import { CustomLinkService } from './custom-link.service';

@Injectable({
  providedIn: 'root',
})
export class OndernemingService {
  
  ref: AngularFireStorageReference;

  //Constante var om typfouten te vermijden
  dbTable ='Onderneming'
  ondernemingDoc: AngularFirestoreDocument<Onderneming>;
  constructor(
    private firestore: AngularFirestore,
    private afStorage: AngularFireStorage,
    private router: Router, public toastComponent: ToastComponent,
    public dataService: DataService,
    
    private vaaService: VaaService,
    private holidayValueService: HolidayValueService,
    private cash4BikeService: Cash4BikeService,
    private customLinkService: CustomLinkService,
    private aanwerfSimulatorService: AanwerfSimulatorService
    
    
    ) {
    this.toastComponent = toastComponent;
  }


  getOnderneming(naam: string): Observable<Onderneming> {
    return this.firestore.collection<Onderneming>(this.dbTable, ref => ref.where('naam', '==', naam)).get().pipe(
      map(queryResult => {
        if (!queryResult.empty) {
          const onderneming = queryResult.docs[ 0 ];
          const data = onderneming.data();
          const id = onderneming.id;
          if (data.logo_id) {
            data.logo = this.afStorage.ref('/' + data.logo_id).getDownloadURL().pipe(take(1), catchError(error => {
              return throwError(error);
            }));
          }
          this.dataService.setOnderneming(data);
          document.documentElement.style.setProperty('--primaryColor', data.kleur);
          document.documentElement.style.setProperty('--btnColor', data.kleurKnoppen);
          // type file verwijderen wanneer we logo's kunnen toevoegen via het adminscherm
          // data.logo = this.afStorage.ref("/" + naam).getDownloadURL().pipe(take(1))
          return { id, ...data };
        } else {
          this.router.navigateByUrl('pagina-niet-gevonden');
          return null;
        }
      }));
  }

  streamOndernemingId(ondernemingId: string): Observable<Onderneming> {
    return this.firestore.collection(this.dbTable).doc<Onderneming>(ondernemingId).snapshotChanges().pipe(
      map(changes => {
        if (changes.payload.exists) {
          const data = changes.payload.data();
          const id = changes.payload.data().id;
          document.documentElement.style.setProperty('--primaryColor', data.kleur);
          document.documentElement.style.setProperty('--btnColor', data.kleurKnoppen);

          this.dataService.setOnderneming(data);
          return { id, ...data };
        } else {
          throwError(new Error(`Onderming with naam ${ondernemingId} does not exist or has been deleted`));
        }
      }));
  }


 //**
 // * realtime ophalen van informatie
 //
 // * @param ondernemingNaam  Name of the Company
 // * @returns  all the data that belongs with the company
 // */
  streamOndernemingNaam(ondernemingNaam: string): Observable<Onderneming> {
    return this.firestore.collection<Onderneming>(this.dbTable, ref => ref.where('naam', '==', ondernemingNaam)).snapshotChanges()
    .pipe(map(changes => {
        return changes.map(change => {
          
          const data = change.payload.doc.data() as Onderneming;
          const _id = change.payload.doc.id

          document.documentElement.style.setProperty('--primaryColor', data.kleur);
          document.documentElement.style.setProperty('--btnColor', data.kleurKnoppen);

          this.dataService.setOnderneming(data);
          return {_id, ...data};
        })[0];

      }));
  }

  // Voorbeeld van realtime veranderingen
  //  streamOndernemingNaam(naam: string): Observable<Onderneming> {
  //    return this.firestore.collection('Onderneming',ref => ref.where('naam', '==', naam)).doc<Onderneming>(naam).snapshotChanges().pipe(
  //      map(changes => {
  //        if (changes.payload.exists) {
  //          return { naam, ...changes.payload.data() };
  //        } else {
  //          throwError(new Error(`Onderming with naam ${naam} does not exist or has been deleted`));
  //        }
  //      }));
  //  }
  getAllOndernemingen()
  {
    return this.firestore.collection(this.dbTable).snapshotChanges().pipe(
      map(changes => {
        return changes.map(a => {
          const data = a.payload.doc.data() as Onderneming;
          data.id = a.payload.doc.id;
          return data;
        });
      })
    )
  }



  getOndernemingId(id: string): Observable<Onderneming> {
    return this.firestore.collection(this.dbTable, ref => ref.where('id', '==', id)).get().pipe(take(1),
      map(queryResult => {

        if (!queryResult.empty) {
          const onderneming = queryResult.docs[ 0 ];
          const data = onderneming.data() as Onderneming;
          const id = onderneming.id;
          this.dataService.setOnderneming(data);
          document.documentElement.style.setProperty('--primaryColor', data.kleur);
          document.documentElement.style.setProperty('--btnColor', data.kleurKnoppen);
          return { id, ...data };
        } else {
          return null;
        }
      }));
  }
  getOndernemingNaam(naam: string): Observable<Onderneming> {
    return this.firestore.collection(this.dbTable, ref => ref.where('naam', '==', naam)).get().pipe(take(1),
      map(queryResult => {

        if (!queryResult.empty) {
          const onderneming = queryResult.docs[ 0 ];
          const data = onderneming.data() as Onderneming;
          const id = onderneming.id;
          this.dataService.setOnderneming(data);
          document.documentElement.style.setProperty('--primaryColor', data.kleur);
          document.documentElement.style.setProperty('--btnColor', data.kleurKnoppen);
          return { id, ...data };
        } else {
          return null;
        }
      }));
  }

  deleteLogo(id: string) {
    this.ref = this.afStorage.ref(id);
    return this.ref.delete().toPromise();
  }


  //TODO Code nog aanpassen naar nieuw systeem met naam
  async addOnderneming(onderneming: Onderneming)
  {
    let ondernemingId = "";
    let ondernemingNaam ="";
    await this.firestore.collection(this.dbTable).add(onderneming).then(function(docRef){
      ondernemingId = docRef.id;
      ondernemingNaam = onderneming.naam;
    })
    onderneming.id = ondernemingId;
    let vaaId = await this.vaaService.addVaa() ;
    let holidayValuelId = await this.holidayValueService.addHolidayValue();
    let customLinkId = await this.customLinkService.addCustomLink();
    let cash4BikeId = await this.cash4BikeService.addCash4Bike();
    let aanwerfSimulatorId = await this.aanwerfSimulatorService.addAanwerfSimulator();
    
    onderneming.vaa = vaaId;
    onderneming.holidayValue = holidayValuelId;
    onderneming.customLink = customLinkId;
    onderneming.cash4Bike = cash4BikeId;
    onderneming.aanwerfSimulator = aanwerfSimulatorId;

    this.updateOnderneming(onderneming);

    this.vaaService.updateNaToevoegen(vaaId,ondernemingId,ondernemingNaam);
    this.holidayValueService.updateNaToevoegen(holidayValuelId,ondernemingId,ondernemingNaam);
    this.customLinkService.updateNaToevoegen(customLinkId,ondernemingId,ondernemingNaam);
    this.cash4BikeService.updateNaToevoegen(cash4BikeId,ondernemingId,ondernemingNaam);
    this.aanwerfSimulatorService.updateNaToevoegen(aanwerfSimulatorId,ondernemingId,ondernemingNaam);
  }

  async updateOnderneming(onderneming: Onderneming) {
    try {
      document.documentElement.style.setProperty('--primaryColor', onderneming.kleur);
      document.documentElement.style.setProperty('--btnColor', onderneming.kleurKnoppen);

      this.ondernemingDoc = this.firestore.doc(`Onderneming/${onderneming.id}`);

      await this.ondernemingDoc.update(onderneming);

      this.dataService.setOnderneming(onderneming);

      this.toastComponent.showSuccess();
    } catch (err) {
      console.log('error in update:' + err);
    }
  }

  async deleteOnderneming(onderneming: Onderneming){
    
    this.vaaService.deleteVaa(onderneming.vaa);
    this.holidayValueService.deleteHolidayValue(onderneming.holidayValue);
    this.customLinkService.deleteCustomLink(onderneming.customLink);
    this.cash4BikeService.deleteCash4Bike(onderneming.cash4Bike);
    this.aanwerfSimulatorService.deleteAanwerfSimulator(onderneming.aanwerfSimulator);
    if (onderneming.logo_id) {
      try {
        await this.deleteLogo(onderneming.logo_id);
      } catch (e) {
        console.log('Failed to delete logo, ignoring error');
      }
    }
    this.ondernemingDoc = this.firestore.doc(`Onderneming/${onderneming.id}`);

    this.ondernemingDoc.delete().then(function(){
      console.log("document is succesvol verwijderd")
    })
  }
}
